<template>
    <div>
      <el-row style="margin-bottom:10px;">
        <el-col>
          <el-button
            @click="$form('settingPromotionForPc')"

            remark="👆上面是自定义的,👇下面是固定的无需修改"

            size='small'
            type="primary"
            style="float:right"
            icon='el-icon-circle-plus' >新增目录</el-button>
        </el-col>
      </el-row>

      <mytable
        :tableColums='tableColums'
        api='getAuthList::authId'
        updateapi='updateAtuh'
        :height="H-164"
        >
        <icol slot='authType' slot-scope='{row}' >{{ row.authType }}</icol>
        <icol slot='authParentId' slot-scope='{row}' >{{ row.authParentId }}</icol>
      </mytable>

      <myform
        :viewobj='{
             addRole: [ "新增角色信息", "el-icon-circle-plus" ],
            updateAtuh: [ "修改角色信息", "el-icon-edit-outline"],
           $succeed$: selectRole
          }'
        @close='$form("editRole","reset")'>
        <hide slot='id'/>
      </myform>

      <myform view.sonmenu='查看子菜单#el-icon-circle-plus#新增子菜单' width='85%' id='FormTop' @confirm='addMenu' >
        <mytable ref='sonmenu'
          :tableColums='tableColums'
          api='getAuthList2::authId'
          updateapi='updateAtuh'
          :height="H-394"
          >
          <icol slot='authType' slot-scope='{row}' >{{ row.authType }}</icol>
          <icol slot='authParentId' slot-scope='{row}' >{{ row.authParentId }}</icol>
        </mytable>
      </myform>

      <!-- <mytable
        :tableColums='tableColums'
        data='getAuthList2'
        api='getAuthList::authId'
        :height="H-164"
        >
        <icol slot='authType' slot-scope='{row}' >{{ row.authType }}</icol>
        <icol slot='authParentId' slot-scope='{row}' >{{ row.authParentId }}</icol>
      </mytable> -->

      <!-- <myform view.addAuth='导入路由页面#el-icon-circle-plus#保存' width='85%' top='50px'
        @close='arguments[1] && $form("addAuth",false)'
        @show='1'
        @confirm='confirm'
        >
      </myform> -->
    </div>
</template>

<script>
  export default {
    data() {
      return {
        
        'tableColums': {

          authId : [ "主键id", 70 ],

          authName : ["名称"], // 目录

          authType : [ "authType" ],

          authParentId : [ "authParentId" ],

          authOrder : [ "排序" ], // 目录

          createtime: [ "创建时间", 250 ],

          // location : ["推广任务位置", 120 ,"@v-if: 0:列表置顶#success, 1:列表随机#success, 2:列表置尾#success, 3:列表中间#success",],

          $operation : [
            "操作 | fixed:right", 200,

            /*`@text: 启用#primary
             @v-if:$row.status == 0
             @click: $trigger("updateSettingPromotionReward",{id: $row.id, status: '1'})
                            ("searchPromotionRecord")
            `,*/

            `@text: 编辑#warn
             @click: $form("updateAtuh",$row), console.warn($row)
            `,

            `@text: 删除#danger+
             @click: $form("editSettingPromotionForPc",$row.with("rewardType",$row.ptype));
            `,

            `@text: {{ $row.authType == 0 ? "子菜单" : "子功能" }}#success
             @click: $form("sonmenu").then(form=>form.title+=" | 《" + $row.authName + "》"), getAuthList2({authType:1,authParentId:$row.authId});
            `,

            /* 👆 这里的 $trigger() 是用来【！触发！】上面的 v-event 的 👆 {id: $row.id,name: $row.name, introduce: $row.introduce, promotionNumber: $row.promotionNumber, discount: $row.discount, location: $row.location, rewardType: $row.ptype, effectiveTime: $row.effectiveTime, promotionLink: $row.promotionLink, richText: $row.richText} */
          ]
        },


      };
    },

    watch: {

    },
    methods: {
      async addMenu(){
        const res = this.getAuthList2_data, data = res.data;
        data.push(({
          authIcon: null,
          authId: "",
          authName: "",
          authOrder: data.length + 1,
          authParams: "",
          authParentId: res.authParentId,
          authRemark: "",
          authType: 1,
          authUrl: "",
          createtime: A.time('auto'),
          createuserid: null,
          ownership: null,
        }).with(data[0]));
        await sleep(1);
        // this.$form("updateAtuh",data.item(-1));
        this.$refs.sonmenu.$refs.table.$refs.bodyWrapper.querySelectorAll('tr')._item(-1).querySelectorAll('button')._item(0).click();
      },
    },

    created() {
      this.getAuthList({authType: 0, authParentId: 0});  
    },

    mounted() {
      // console.error(11111111);
      // this.$form('addAuth'); // $form("addAuth",false)
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/AuthList/AuthList2.vue